{
  "name": "@dialectlabs/sdk",
  "version": "1.9.5",
  "type": "module",
  "repository": "git@github.com:dialectlabs/sdk.git",
  "author": "dialectlabs",
  "license": "Apache-2.0",
  "sideEffects": false,
  "main": "dist/index.cjs",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    }
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "clean": "rm -rf lib",
    "lint": "eslint \"{src,test}/**/*.ts\" --fix",
    "build": "tsup-node",
    "dev": "tsup-node --watch",
    "token:generate": "ts-node examples/generate-token.ts",
    "test": "jest",
    "format": "prettier --write \"src/**/*.ts\" \"test/**/*.ts\""
  },
  "devDependencies": {
    "@solana/wallet-adapter-base": "^0.9.15",
    "@solana/web3.js": "^1.53.0",
    "@types/bs58": "^4.0.1",
    "@types/ed2curve": "^0.2.2",
    "mockdate": "^3.0.5"
  },
  "dependencies": {
    "@stablelib/base64": "^1.0.1",
    "axios": "^0.27.2",
    "bs58": "^5.0.0",
    "ed2curve": "^0.3.0",
    "js-sha3": "^0.8.0",
    "nanoid": "^3.3.4",
    "tweetnacl": "^1.0.3"
  }
}
